import type { SVGProps } from 'react';

const Globe = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      // width="25"
      // height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.8789 12C19.8789 16.0041 16.633 19.25 12.6289 19.25C8.62484 19.25 5.37891 16.0041 5.37891 12C5.37891 7.99594 8.62484 4.75 12.6289 4.75C16.633 4.75 19.8789 7.99594 19.8789 12Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8789 12C15.8789 16.5 13.8715 19.25 12.6289 19.25C11.3863 19.25 9.37891 16.5 9.37891 12C9.37891 7.5 11.3863 4.75 12.6289 4.75C13.8715 4.75 15.8789 7.5 15.8789 12Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.62891 12H19.6289"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Globe;
